<script>
import { Bar } from "vue-chartjs";

const defaultOptions = {
  scales: {
    yAxes: [
      {
        ticks: { beginAtZero: true },
        gridLines: { display: true }
      }
    ],
    xAxes: [
      {
        gridLines: { display: false }
      }
    ]
  },
  legend: { display: true },
  responsive: true,
  maintainAspectRatio: false
};

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      required: true
    },
    chartData: {
      type: Array,
      required: true
    },
    extraOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    transformedChartData() {
      return {
        labels: this.labels,
        datasets: this.chartData
      };
    },
    mergedOptions() {
      const extra = this.extraOptions;
      if (!extra || !Object.keys(extra).length) return defaultOptions;
      return {
        ...defaultOptions,
        ...extra,
        scales: {
          ...defaultOptions.scales,
          ...(extra.scales || {}),
          yAxes:
            extra.scales && extra.scales.yAxes
              ? extra.scales.yAxes
              : defaultOptions.scales.yAxes,
          xAxes:
            extra.scales && extra.scales.xAxes
              ? extra.scales.xAxes
              : defaultOptions.scales.xAxes
        }
      };
    }
  },
  mounted() {
    this.renderChart(this.transformedChartData, this.mergedOptions);
  }
};
</script>
